module.exports = __webpack_public_path__ + "static/media/goal-progress.480b6ab5.png";